import { MapPin, Phone, MessageCircle, Layers } from "lucide-react";
import { IMAGES, LOGO } from "@/content";

/**
 * Vorschau: AKTUELLES Dark-Design, aber Headline-Schrift "Anton"
 * (Manga-Stil aus Variante 1). Route: /preview-fonts
 * Vergleich: links bisherige Schrift (Bebas Neue), rechts neue (Anton).
 */

const Hero = ({ font, label, testid }) => (
  <section
    data-testid={testid}
    className="relative flex min-h-[88vh] items-center overflow-hidden border-b border-border"
  >
    <div className="absolute inset-0 overflow-hidden">
      <div className="cover-frame">
        <img src={IMAGES.heroArt} alt="" aria-hidden className="h-full w-full" />
      </div>
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(90deg, hsl(20 14% 4.5% / 0.94) 0%, hsl(20 14% 4.5% / 0.8) 38%, hsl(18 30% 8% / 0.35) 70%, hsl(20 20% 5% / 0.3) 100%)",
        }}
      />
      <div className="hero-glow absolute inset-0" />
      <div className="bg-grid absolute inset-0" />
    </div>

    <div
      aria-hidden
      className="neon-flicker pointer-events-none absolute right-6 top-1/2 z-10 hidden -translate-y-1/2 select-none lg:block"
    >
      <p className="neon-kanji kanji-vertical text-5xl">渋谷ストア</p>
    </div>

    <span className="absolute left-6 top-6 z-20 rounded-full bg-white px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-black">
      {label}
    </span>

    <div className="relative z-10 mx-auto w-full max-w-6xl px-4 py-20 sm:px-6">
      <div className="max-w-2xl">
        <img src={LOGO} alt="Shibuya Logo" className="h-16 w-auto md:h-24" />
        <span className="mt-8 inline-flex items-center rounded-full border border-primary/40 bg-primary/10 px-4 py-1.5 font-mono-ui text-[11px] uppercase tracking-widest text-primary backdrop-blur-sm">
          <MapPin className="mr-1.5 h-3 w-3" /> Köln · Zülpicherstraße 357
        </span>

        <h1
          className="mt-5 uppercase leading-[0.9] tracking-[0.02em] text-foreground"
          style={{ fontFamily: font, fontSize: "clamp(3rem,6.5vw,5.5rem)" }}
        >
          Dein Anime- &amp;
          <br />
          TCG-Spot <span className="neon-text">in Köln</span>
        </h1>

        <p className="mt-5 max-w-xl text-base leading-relaxed text-muted-foreground md:text-lg">
          Tokyo-Style trifft Sammlerherz: Pokémon, One Piece &amp; viele weitere
          TCGs, detailreiche Anime-Figuren und eine Community, die tauscht,
          spielt und fachsimpelt.
        </p>

        <div className="mt-8 flex flex-wrap items-center gap-3">
          <button className="flex h-12 items-center rounded-xl bg-primary px-6 font-medium text-primary-foreground shadow-[0_10px_30px_hsl(22_100%_50%/0.35)]">
            <Phone className="mr-2 h-5 w-5" /> Jetzt anrufen
          </button>
          <button className="flex h-12 items-center rounded-xl border border-primary/30 bg-background/40 px-6 backdrop-blur-sm">
            <MessageCircle className="mr-2 h-5 w-5" /> WhatsApp
          </button>
        </div>

        {/* Section-Heading Beispiel */}
        <div className="mt-12 border-t border-border pt-8">
          <div className="flex items-center gap-3">
            <p className="font-mono-ui text-xs uppercase tracking-[0.25em] text-primary">01 / Was dich erwartet</p>
            <span className="neon-kanji-orange text-sm">三つの世界</span>
          </div>
          <h2
            className="mt-3 uppercase tracking-[0.02em] text-foreground"
            style={{ fontFamily: font, fontSize: "clamp(2rem,4vw,3.2rem)" }}
          >
            Drei Welten. <span className="neon-text">Ein Store.</span>
          </h2>
          <div className="mt-4 inline-flex items-center gap-2 rounded-xl border border-border bg-card p-4">
            <Layers className="h-5 w-5 text-primary" />
            <span className="uppercase tracking-wide text-foreground" style={{ fontFamily: font, fontSize: "1.4rem" }}>
              TCG – Karten &amp; Produkte
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default function FontPreview() {
  return (
    <div data-testid="font-preview-page" className="min-h-screen bg-background">
      <div className="px-6 py-8 text-center">
        <p className="font-mono-ui text-xs uppercase tracking-[0.3em] text-primary">Schrift-Vergleich im aktuellen Design</p>
        <h1 className="mt-2 text-2xl font-bold text-foreground">Aktuelles Dark-Design + Manga-Schrift</h1>
        <p className="mx-auto mt-2 max-w-2xl text-sm text-muted-foreground">
          Oben: BISHER (Bebas Neue). Unten: NEU mit „Anton" aus Variante 1 –
          blockiger, kräftiger, mangahafter. Gleiche Farben & Effekte.
        </p>
      </div>

      <Hero font="'Bebas Neue', sans-serif" label="Bisher · Bebas Neue" testid="hero-current-font" />
      <Hero font="'Anton', sans-serif" label="Neu · Anton (Manga)" testid="hero-anton-font" />

      <div className="px-6 py-12 text-center">
        <p className="text-sm text-muted-foreground">
          Gefällt dir die untere Schrift? Sag <span className="font-bold text-foreground">„ja, umsetzen"</span> – dann wechsle ich die Headline-Schrift auf der ganzen Seite.
        </p>
      </div>
    </div>
  );
}
